import { render, staticRenderFns } from "./Licences.vue?vue&type=template&id=14b3209c&scoped=true&"
import script from "./Licences.vue?vue&type=script&lang=js&"
export * from "./Licences.vue?vue&type=script&lang=js&"
import style0 from "./Licences.vue?vue&type=style&index=0&id=14b3209c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b3209c",
  null
  
)

export default component.exports